import {ActionTree, ActionContext} from 'vuex';
import {AlertNotificationModuleConstant, ClubModuleConstant, ProfileModuleConstant, UrlModuleConstant} from '../constants';
import Deferred from '../deferred';
import LtFramework from 'types/lt/ltFramework';

export const AlertNotificationActions: ActionTree<LtFramework.IAlertNotificationState, LtFramework.IRootState> = {
	open(action: ActionContext<LtFramework.IAlertNotificationState, LtFramework.IRootState>, payload: LtFramework.IAlertNotification): Promise<void> {
		return window.LtFramework.alertNotificationStore.open(payload);
	},
	close(action: ActionContext<LtFramework.IAlertNotificationState, LtFramework.IRootState>, payload: LtFramework.IAlertNotification) {
		return window.LtFramework.alertNotificationStore.close(payload);
	},
	synchronize(action: ActionContext<LtFramework.IAlertNotificationState, LtFramework.IRootState>, payload: LtFramework.IAlertNotification[]): Promise<boolean> {
		let alertStoreInitialized: boolean = false;
		const alertStoreDeferred: Deferred<boolean> = new Deferred();
		const alertNotifications: any = window.LtFramework.getStore('AlertNotificationStore').getInitialData();

		if (!alertStoreInitialized && alertNotifications) {
			action.commit(AlertNotificationModuleConstant.mutation.setAlertNotifications, alertNotifications);

			alertStoreInitialized = true;
			alertStoreDeferred.resolve(alertStoreInitialized);
		}

		// window.LtFramework.alertNotificationStore.listen((arr: LtFramework.IAlertNotification[]) => {
		// 	if (typeof arr !== undefined) {
		// 		action.commit(AlertNotificationModuleConstant.mutation.setAlertNotifications, arr);

		// 		if (!alertStoreInitialized) {
		// 			alertStoreInitialized = true;
		// 			alertStoreDeferred.resolve(alertStoreInitialized);
		// 		}
		// 	}
		// });

		return alertStoreDeferred.promise;
	},
};

export const ClubActions: ActionTree<LtFramework.IClubState, LtFramework.IRootState> = {
	synchronize(action: ActionContext<LtFramework.IClubState, LtFramework.IRootState>): Promise<boolean> {
		let clubStoreInitialized: boolean = false;
		const clubStoreDeferred: Deferred<boolean> = new Deferred();
		const club: any = window.LtFramework.getStore('ClubStore').getInitialData();

		if (!clubStoreInitialized && club) {
			action.commit(ClubModuleConstant.mutation.setClub, club);

			clubStoreInitialized = true;
			clubStoreDeferred.resolve(clubStoreInitialized);
		}

		// window.LtFramework.clubStore.listen((obj: LtFramework.IProfile) => {
		// 	if (obj) {
		// 		action.commit(ProfileModuleConstant.mutation.setProfile, obj);

		// 		if (!clubStoreInitialized && obj && obj.initialized) {
		// 			clubStoreInitialized = true;
		// 			clubStoreDeferred.resolve(clubStoreInitialized);
		// 		}
		// 	}
		// });

		return clubStoreDeferred.promise;
	},
};

export const ProfileActions: ActionTree<LtFramework.IProfileState, LtFramework.IRootState> = {
	synchronize(action: ActionContext<LtFramework.IProfileState, LtFramework.IRootState>): Promise<boolean> {
		let profileStoreInitialized: boolean = false;
		const profileStoreDeferred: Deferred<boolean> = new Deferred();
		const profile: any = window.LtFramework.getStore('ProfileStore').getInitialData();

		if (!profileStoreInitialized && profile) {
			action.commit(ProfileModuleConstant.mutation.setProfile, profile);

			profileStoreInitialized = true;
			profileStoreDeferred.resolve(profileStoreInitialized);
		}

		// window.LtFramework.profileStore.listen((obj: LtFramework.IProfile) => {
		// 	if (obj) {
		// 		action.commit(ProfileModuleConstant.mutation.setProfile, obj);

		// 		if (!profileStoreInitialized && obj && obj.initialized) {
		// 			profileStoreInitialized = true;
		// 			profileStoreDeferred.resolve(profileStoreInitialized);
		// 		}
		// 	}
		// });

		return profileStoreDeferred.promise;
	},
};

export const UrlActions: ActionTree<LtFramework.IUrlState, LtFramework.IRootState> = {
	synchronize(action: ActionContext<LtFramework.IUrlState, LtFramework.IRootState>): Promise<boolean> {
		let urlStoreInitialized: boolean = false;
		const urlStoreDeferred: Deferred<boolean> = new Deferred();
		const urlStore: any = window.LtFramework.getStore('UrlStore').getInitialData();

		if (!urlStoreInitialized && urlStore) {
			action.commit(UrlModuleConstant.mutation.setUrl, urlStore);

			urlStoreInitialized = true;
			urlStoreDeferred.resolve(urlStoreInitialized);
		}

		// window.LtFramework.urlStore.listen((obj: LtFramework.IUrl) => {
		// 	if (obj) {
		// 		action.commit(UrlModuleConstant.mutation.setUrl, obj);

		// 		if (!urlStoreInitialized && obj && obj.initialized) {
		// 			urlStoreInitialized = true;
		// 			urlStoreDeferred.resolve(urlStoreInitialized);
		// 		}
		// 	}
		// });

		return urlStoreDeferred.promise;
	},
};
